import { Link } from 'react-router-dom'
import { FiChevronRight as FiBreadcrumb } from 'react-icons/fi'
import Layout from '../components/Layout/Layout'

const Privacy = () => {
  const privacyData = [
    {
      id: 1,
      question: '',
      answer: 'Leonardo Alcalá Torres, en adelante "El Responsable", con domicilio ubicado en Calle Zaragoza No. 52, Ayotlán, C.P. 47930, Ayotlán, Jalisco, México, pone a su disposición el presente Aviso de Privacidad, en cumplimiento a lo dispuesto por la Ley Federal de Protección de Datos Personales en Posesión de los Particulares (la "Ley") y su Reglamento.'
    },
    {
      id: 2,
      question: 'DATOS PERSONALES QUE SE RECABAN',
      answer: 'Se hace del conocimiento del Usuario que el presente sitio web funciona exclusivamente como un escaparate digital e informativo. Por lo tanto, en este sitio web NO se recaban, almacenan, ni procesan datos personales de los visitantes, ni se solicitan datos bancarios, nombres, direcciones o información de contacto a través de formularios directos en la web.'
    },
    {
      id: 3,
      question: 'FINALIDAD DEL TRATAMIENTO',
      answer: 'El acceso a este sitio web tiene como única finalidad:'
    },
    {
      id: 4,
      question: '',
      answer: 'Mostrar el catálogo de productos y su información detallada.'
    },
    {
      id: 5,
      question: '',
      answer: 'Proporcionar información pública sobre precios y características.'
    },
    {
      id: 6,
      question: '',
      answer: 'Redirigir al usuario interesado hacia la aplicación móvil oficial en Android para concretar cualquier proceso de compra.'
    },
    {
      id: 7,
      question: 'USO DE COOKIES Y TECNOLOGÍAS DE RASTREO',
      answer: 'Le informamos que en este sitio web NO utilizamos cookies, web beacons ni otras tecnologías de rastreo para monitorear su comportamiento como usuario de internet, ni para recabar información personal técnica. La navegación es completamente anónima y no intrusiva.'
    },
    {
      id: 8,
      question: 'TRANSFERENCIA DE DATOS',
      answer: 'Al no recabar datos personales en este portal web, "El Responsable" no realiza transferencias de datos a terceros nacionales ni extranjeros desde este sitio.'
    },
    {
      id: 9,
      question: 'COMPRAS Y TRANSACCIONES',
      answer: 'Cualquier transacción comercial, compra o suministro de datos personales bancarios y de identificación se realizará única y exclusivamente a través de nuestra Aplicación Móvil. Se invita al usuario a consultar el Aviso de Privacidad específico dentro de dicha Aplicación antes de realizar cualquier compra, ya que ese entorno opera de manera independiente y bajo sus propios protocolos de seguridad.'
    },
    {
      id: 10,
      question: 'DERECHOS ARCO (Acceso, Rectificación, Cancelación y Oposición)',
      answer: 'Aunque este sitio web no recaba datos, usted tiene derecho a conocer qué información podríamos tener de usted (en caso de que nos haya contactado voluntariamente por otros medios externos a la web, como correo electrónico), para qué la utilizamos y las condiciones del uso que les damos. Para el ejercicio de cualquiera de los derechos ARCO, usted deberá presentar la solicitud respectiva a través del siguiente medio de contacto oficial:'
    },
    {
      id: 11,
      question: '',
      answer: 'Correo electrónico: coronasguadalupe@gmail.com'
    },
    {
      id: 12,
      question: 'CAMBIOS AL AVISO DE PRIVACIDAD',
      answer: 'El presente aviso de privacidad puede sufrir modificaciones, cambios o actualizaciones derivadas de nuevos requerimientos legales; de nuestras propias necesidades por los productos o servicios que ofrecemos; o por cambios en nuestro modelo de negocio. Nos comprometemos a mantenerlo informado sobre los cambios que pueda sufrir el presente aviso de privacidad mediante su publicación en este mismo sitio web.'
    },
    {
      id: 13,
      question: '',
      answer: 'Última actualización: 03 de febrero de 2026'
    }
  ]

  return (
    <Layout>
      <div className="py-8 sm:py-12">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          {/* Breadcrumb */}
          <nav className="flex items-center text-sm sm:text-base text-primary-gray mb-4 sm:mb-6 font-body font-extralight flex-wrap" aria-label="Breadcrumb">
            <Link to="/" className="hover:text-primary-dark hover:font-normal transition-colors">
              Inicio
            </Link>
            <FiBreadcrumb className="mx-1 sm:mx-2 flex-shrink-0" />
            <span className="font-normal">
              Aviso de Privacidad
            </span>
          </nav>

          {/* Page Header */}
          <div className="mb-8">
            <h1 className="text-2xl sm:text-3xl lg:text-4xl font-title font-semibold text-primary-text mb-4">
              Aviso de privacidad
            </h1>
          </div>
                    
          {/* Privacy List - Static Display */}
          <div className="space-y-6">
            {privacyData.map((item) => (
              <div key={item.id}>
                <h3 className="font-normal text-primary-text text-xl font-body mb-2">
                  {item.question}
                </h3>
                <p className="font-light text-primary-text text-lg font-body leading-relaxed ml-4">
                  {item.answer}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </Layout>
  )
}

export default Privacy